import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import moment from 'moment/moment'
import { useNavigate, useSearchParams } from 'react-router-dom'
import MessageSquareChatIcon from './../../../../assets/icons/MessageSquareChat.svg?react'

import { FC } from 'react'
import { ProjectItem } from '../../../../components/ProjectItem/ProjectItem'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { ThreadShortDTO } from '../../../../swagger/dto'
import { RegularRequestsChip } from './RegularRequestsChip'
import { RequestItemMenu } from './RequestItemMenu'

type Props = {
    request: ThreadShortDTO
}

export const RequestItem: FC<Props> = ({ request }) => {
    const { name, created_at, id, last_message_timestamp, is_archived, scheduled_reply_count } =
        request
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const { isTempUser } = useWrapperStore((state) => state)

    const workplaceId = searchParams.get('workplaceId')
        ? `&workplaceId=${searchParams.get('workplaceId')}`
        : ''
    return (
        <>
            <Grid
                spacing={2}
                container
                sx={{
                    width: '100%',
                    p: 1,
                    mb: 0.5,
                    '&:hover': { background: '#F4F4F6' },
                    justifyContent: 'space-between',
                }}>
                <Grid
                    sx={{
                        height: '40px',
                        width: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                    <MessageSquareChatIcon color="#8F93A3" />
                </Grid>
                <Grid
                    size="grow"
                    sx={{
                        cursor: 'pointer',
                        alignItems: 'center',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                    }}
                    onClick={() =>
                        navigate(`/request/${id}?is_archived=${is_archived}${workplaceId}`)
                    }>
                    <Typography
                        variant="body2"
                        sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            color: '#181B25',
                            mb: 0.5,
                        }}>
                        {name}
                    </Typography>
                    <Grid sx={{ display: 'flex' }}>
                        <Typography
                            variant="caption2"
                            component="span"
                            sx={{ color: '#9195A1', mr: 1 }}>
                            {moment(last_message_timestamp ?? created_at).format(
                                'DD MMMM YYYY, HH:mm',
                            )}
                        </Typography>
                        <ProjectItem projectId={request.workplace_id} />
                    </Grid>
                    {!!scheduled_reply_count && !is_archived && !isTempUser && (
                        <RegularRequestsChip requestsCount={scheduled_reply_count} />
                    )}
                </Grid>
                <Grid size="auto">
                    <RequestItemMenu request={request} />
                </Grid>
            </Grid>

            <Divider sx={{ color: '#F4F4F6', mb: 1 }} />
        </>
    )
}
